module.exports = "../../app/cells/components/applied_test_cell.rb";